import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Error', null, { withChildren: true });
